export default function () {
  this.loadProfessional()
}



// WEBPACK FOOTER //
// ./src/app/professional/curriculum/graduations/form/resources/mounted.js